import React from 'react'

function Java_program_details() {
  return (
    <div>
      {/* -----------------Mobile view---------------------- */}
      <div className="d-sm-block d-md-none">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-6">Sip into java mastery</h1>
                <p className="py-2">
                  Enrol now in our advanced Java program! Unlock the gateway to
                  a bright future as you master the art of coding. Dive into
                  excellence today!
                </p>
              </div>
              <div className="mt-4 text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  Take a thorough tour of Core Java and learn about basic ideas
                  like classes, objects, packages, data types, and methods.
                  Explore more complex subjects such as inner classes,
                  encapsulation, inheritance, polymorphism, static and final
                  keywords, and abstraction. Learn about the differences between
                  Core and Advanced Java, Java applications, Hibernate and
                  Spring frameworks, and how to create standalone, web,
                  enterprise, and mobile applications. Finish with practical
                  experience gained from small and large projects, demonstrating
                  your mastery of this flexible programming language.
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div>
                <div className=" Details_container shadow-lg px-1 py-4">
                  <h1 className="Details_text text-center  pb-2 border-bottom">
                    Java
                  </h1>
                  <div className="Details_text">
                    <ul className="pt-2">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------------Desktop View-------------------- */}
      <div className="d-none d-md-block">
        <div className="container">
          <div className="row">
            <div className="col-md-8 detail_1stcomp_img">
              <div className="pt-3 Program_details_1stcomp_text">
                <h1 className="fs-2">Sip into java mastery</h1>
                <p className="py-2">
                  Enrol now in our advanced Java program! Unlock the gateway to
                  a bright future as you master the art of coding. Dive into
                  excellence today!
                </p>
              </div>
              <div className="mt-3 Program_details_1stcomp_text">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  Take a thorough tour of Core Java and learn about basic ideas
                  like classes, objects, packages, data types, and methods.
                  Explore more complex subjects such as inner classes,
                  encapsulation, inheritance, polymorphism, static and final
                  keywords, and abstraction. Learn about the differences between
                  Core and Advanced Java, Java applications, Hibernate and
                  Spring frameworks, and how to create standalone, web,
                  enterprise, and mobile applications. Finish with practical
                  experience gained from small and large projects, demonstrating
                  your mastery of this flexible programming language.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div>
                <div className=" Details_container shadow-lg px-3 py-4">
                  <h1 className="Details_text text-center  pb-4 pt-3 border-bottom">
                    Java
                  </h1>
                  <div className="Details_text ">
                    <ul className="pt-3">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Java_program_details
